module.exports = __webpack_public_path__ + "static/media/cases_impressos_nec_02.facfa273.jpg";